/* eslint-disable no-param-reassign */

const toCharSize = x => `${String(x).length + 5}ch`;
export default {
	inserted(el, binding) {
		const key = binding.value || 'textContent';
		el.style.width = toCharSize(el[key]);
	},
	componentUpdated(el, binding) {
		const key = binding.value || 'textContent';
		el.style.width = toCharSize(el[key]);
	},
};



// WEBPACK FOOTER //
// ./src/directives/growable.js